
import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarTrigger,
} from "@/components/ui/sidebar";
import { Keyboard, Mic, BarChart2, LogOut, Brain } from "lucide-react";
import { useIsMobile } from '@/hooks/use-mobile';
import { toast } from 'sonner';

export function AppSidebar() {
  const location = useLocation();
  const isMobile = useIsMobile();

  const isActive = (path: string) => location.pathname === path;
  
  const handleLogout = () => {
    // Clear stored user data
    localStorage.removeItem('user');
    sessionStorage.removeItem('user');
    toast.success('Successfully logged out');
    window.location.reload(); // Reload to update UI state
  };
  
  // Check if user is logged in
  const isLoggedIn = !!JSON.parse(localStorage.getItem('user') || sessionStorage.getItem('user') || 'null');

  return (
    <>
      <div className="fixed top-4 left-4 z-50 md:hidden">
        <SidebarTrigger />
      </div>
      <Sidebar>
        <SidebarHeader>
          <div className="px-3 py-2">
            <h2 className="text-lg font-semibold">Domain Analysis</h2>
            <p className="text-xs text-muted-foreground">Evaluate your domains</p>
          </div>
        </SidebarHeader>
        <SidebarContent>
          <SidebarGroup>
            <SidebarGroupLabel>Analyzers</SidebarGroupLabel>
            <SidebarGroupContent>
              <SidebarMenu>
                <SidebarMenuItem>
                  <SidebarMenuButton
                    asChild
                    isActive={isActive('/')}
                    tooltip="Typability Analyzer"
                  >
                    <Link to="/">
                      <Keyboard />
                      <span>Typability</span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
                <SidebarMenuItem>
                  <SidebarMenuButton
                    asChild
                    isActive={isActive('/speakability')}
                    tooltip="Speakability Analyzer"
                  >
                    <Link to="/speakability">
                      <Mic />
                      <span>Speakability</span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
                <SidebarMenuItem>
                  <SidebarMenuButton
                    asChild
                    isActive={isActive('/memorability')}
                    tooltip="Memorability Analyzer"
                  >
                    <Link to="/memorability">
                      <Brain />
                      <span>Memorability</span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
                <SidebarMenuItem>
                  <SidebarMenuButton
                    asChild
                    isActive={isActive('/compare')}
                    tooltip="Compare Domains"
                  >
                    <Link to="/compare">
                      <BarChart2 />
                      <span>Compare</span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        </SidebarContent>
        <SidebarFooter>
          <div className="flex flex-col gap-2 px-3 py-2">
            {isLoggedIn && (
              <SidebarMenuButton
                onClick={handleLogout}
                className="w-full justify-start text-red-500 hover:text-red-600"
                tooltip="Logout"
              >
                <LogOut size={18} />
                <span>Logout</span>
              </SidebarMenuButton>
            )}
            <div className="text-xs text-gray-500 mt-2">
              Domain Analysis Tool v1.0
            </div>
          </div>
        </SidebarFooter>
      </Sidebar>
    </>
  );
}
